import React from "react";
import PropTypes from "prop-types";
export function ShareIcon({ color = "#d0021b", width = 21, height = 21 }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 15 17"
    >
      <path
        fill="#1C1C1C"
        fillRule="nonzero"
        d="M11.681 0c-1.515 0-2.758 1.261-2.758 2.8 0 .298.047.591.133.862l-4.554 2.57a2.715 2.715 0 0 0-1.73-.632C1.256 5.6.014 6.861.014 8.4s1.242 2.8 2.758 2.8a2.71 2.71 0 0 0 1.73-.626l4.56 2.571a2.79 2.79 0 0 0-.139.855c0 1.539 1.243 2.8 2.758 2.8s2.758-1.261 2.758-2.8-1.243-2.8-2.758-2.8c-.761 0-1.455.323-1.956.835L5.291 9.53a2.79 2.79 0 0 0 0-2.262l4.428-2.504a2.732 2.732 0 0 0 1.962.835c1.515 0 2.758-1.261 2.758-2.8S13.196 0 11.68 0z"
      />
    </svg>
  );
}

ShareIcon.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number
};
